export default __webpack_public_path__ + "static/media/gestores.2d69d28c.png";